"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _luxon = require("luxon");

var _RangeSlider = _interopRequireDefault(require("./RangeSlider"));

var _FixedWidthSlider = _interopRequireDefault(require("./FixedWidthSlider"));

var _ResizableXYPlot = _interopRequireDefault(require("../ResizableXYPlot"));

var _RecentPerformanceCrosshair = require("../RecentPerformanceCrosshair");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var HoverBody = function HoverBody(_ref) {
  var coordinateCrosshairValues = _ref.coordinateCrosshairValues,
      timeZone = _ref.timeZone;
  return /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.CrosshairDate, {
    dateMillis: coordinateCrosshairValues,
    timeZone: timeZone
  });
};

HoverBody.propTypes = {
  coordinateCrosshairValues: _propTypes["default"].number.isRequired,
  timeZone: _propTypes["default"].string.isRequired
};

var Interaction = /*#__PURE__*/function (_PureComponent) {
  _inherits(Interaction, _PureComponent);

  var _super = _createSuper(Interaction);

  function Interaction() {
    var _this;

    _classCallCheck(this, Interaction);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      hoverValue: null
    };

    _this.changeHoverValue = function (date) {
      var timeZone = _this.props.timeZone;

      if (date) {
        _this.setState({
          hoverValue: _luxon.DateTime.fromJSDate(date, {
            zone: timeZone
          }).toMillis()
        });
      } else {
        _this.setState({
          hoverValue: null
        });
      }
    };

    return _this;
  }

  _createClass(Interaction, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isResizable = _this$props.isResizable,
          maxDate = _this$props.maxDate,
          minDate = _this$props.minDate,
          _onClickDate = _this$props.onClickDate,
          _onDragEnd = _this$props.onDragEnd,
          _onResizeEnd = _this$props.onResizeEnd,
          timeZone = _this$props.timeZone,
          viewEndDate = _this$props.viewEndDate,
          viewStartDate = _this$props.viewStartDate;
      var hoverValue = this.state.hoverValue;
      var minDateMillis = minDate.toMillis();
      var maxDateMillis = maxDate.toMillis();
      return /*#__PURE__*/_react["default"].createElement(_ResizableXYPlot["default"], {
        xType: "time",
        xDomain: [minDateMillis, maxDateMillis],
        height: 100,
        margin: {
          top: 0,
          bottom: 0
        },
        dontCheckIfEmpty: true
      }, isResizable ? /*#__PURE__*/_react["default"].createElement(_RangeSlider["default"], {
        changeHoverValue: this.changeHoverValue,
        end: viewEndDate,
        maxDate: maxDate,
        minDate: minDate,
        onClickDate: function onClickDate(c) {
          return _onClickDate && _onClickDate(c);
        },
        onDragEnd: function onDragEnd(c) {
          return _onDragEnd && _onDragEnd(c);
        },
        onResizeEnd: function onResizeEnd(c) {
          return _onResizeEnd && _onResizeEnd(c);
        },
        start: viewStartDate
      }) : /*#__PURE__*/_react["default"].createElement(_FixedWidthSlider["default"], {
        changeHoverValue: this.changeHoverValue,
        end: viewEndDate,
        maxDate: maxDate,
        minDate: minDate,
        onClickDate: function onClickDate(c) {
          return _onClickDate && _onClickDate(c);
        },
        onDragEnd: function onDragEnd(c) {
          return _onDragEnd && _onDragEnd(c);
        },
        start: viewStartDate
      }), /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.RecentPerformanceCrosshair, {
        coordinate: {
          x: hoverValue
        }
      }, hoverValue && /*#__PURE__*/_react["default"].createElement(HoverBody, {
        coordinateCrosshairValues: hoverValue,
        timeZone: timeZone
      })));
    }
  }]);

  return Interaction;
}(_react.PureComponent);

Interaction.propTypes = {
  isResizable: _propTypes["default"].bool,
  maxDate: _propTypes["default"].instanceOf(_luxon.DateTime).isRequired,
  minDate: _propTypes["default"].instanceOf(_luxon.DateTime).isRequired,
  onClickDate: _propTypes["default"].func,
  onDragEnd: _propTypes["default"].func,
  onResizeEnd: _propTypes["default"].func,
  timeZone: _propTypes["default"].string,
  viewEndDate: _propTypes["default"].instanceOf(_luxon.DateTime).isRequired,
  viewStartDate: _propTypes["default"].instanceOf(_luxon.DateTime).isRequired
};
Interaction.defaultProps = {
  isResizable: false,
  onClickDate: undefined,
  onDragEnd: undefined,
  onResizeEnd: undefined,
  timeZone: ''
};
var _default = Interaction;
exports["default"] = _default;